'use strict';

const onDateRangeChanged = $state => {
	return {
		id: 'onRangeChange',
		f: range => {
			$state.go(
				$state.current,
				{ view: $state.params.view, from: range.from, to: range.to },
				{ notify: false }
			);
		}
	};
};

module.exports = {
	onDateRangeChanged
};
